import React from "react";
import style from "./AdminPanel.module.css";
import MenuBar from "./MenuBarAdmin";
import { useLocation } from "react-router-dom";

const AdminPanel = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const modeFromUrl = params.get("mode");
  const modeFromSession = sessionStorage.getItem("mode");

  const isEmbedded =
    (modeFromUrl && modeFromUrl.toLowerCase() === "admin") ||
    modeFromSession === "admin";

  if (isEmbedded) {
    sessionStorage.setItem("mode", "admin");
  }
  return (
    <div className={style.PurchaseOrderDetails}>
      {/* {!isEmbedded && (
        <div className={style.HeadingBarContainer}>
          <HeadingBar />
        </div>
      )} */}

      <div className={style.PurchaseOrderDetailsContainer}>
        <div className={style.MenuBarContainer}>
          <MenuBar />
        </div>
      </div>
    </div>
  );
};

export default AdminPanel;
